import React, { ReactNode } from 'react'

interface IRadioInput {
    changeHandler: (data: any) => any,
    blurHandler?: (data: any) => any,
    value: string,
    disabled?: boolean,
    checked?: boolean,
    label?: string | ReactNode
    name: string,
    customClassName?: string,
    customLabelClassName?: string,
    customLabel?: React.ComponentType
    require?: boolean,
    id?: string,
}

const Input: React.FC<IRadioInput> = (
    {
        changeHandler,
        disabled = false,
        checked = false,
        label,
        name,
        customClassName,
        customLabelClassName,
        customLabel,
        value,
        blurHandler,
        require = true,
        id,
    }
) => {

    return (
        <>
            <input
                id={id}
                className={`${customClassName ? customClassName : ""}`}
                type="radio"
                name={name}
                onChange={changeHandler}
                onBlur={blurHandler}
                value={value}
                disabled={disabled}
                checked={checked}
                required={require}
            />

            {customLabel ?
                (
                    <div className="flex">
                        {/*@ts-ignore*/}
                        {customLabel}
                    </div>
                )
                :
                label &&
                (
                    <label
                        className={`pl-2 cursor-pointer ${customLabelClassName ? customLabelClassName : ""}`}
                        htmlFor={id}
                    >
                        {label}
                    </label>
                )
            }
        </>
    )
}

export default Input